export const colorHexWithHash = (color: string): string => {
  const colorAsString = color.toString();
  return colorAsString.startsWith('#') ? colorAsString : `#${colorAsString}`;
};

export const colorHexWithoutHash = (color: string): string => {
  const colorAsString = color.toString();
  return colorAsString.startsWith('#') ? colorAsString.substring(1) : colorAsString;
};
